<template>
  <div class="swiperBox"  :style="{position: 'relative',height: styles.height+'rem'}" >
    <div class="swiper-container" :style="{width: styles.width + 'px',position: 'absolute',height: styles.height+'rem',left: '50%',marginLeft: '-3.75rem'}">
      <div class="swiper-wrapper">
           <div v-for="(item, index) in sliderData" :key="index" class="swiper-slide" >
              <img :src="item.FileUrl" :style="{width: styles.width + 'px'}"/>
          </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>

    <!-- 如果需要导航按钮 -->
    <!-- <div  v-if="sliderData.length>1" class="swiper-button-prev" style="left: 50%; margin-left: -620px"></div>
    <div  v-if="sliderData.length>1" class="swiper-button-next" style="left: 50%; margin-left: 600px"></div> -->

    <!-- 如果需要滚动条 -->
    <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css'
export default {
  name: 'slider',
  props: {
   sliderData: { // 图片列表 src数组
      type: Array,
      default: () => []
    },
    isShowPosition: { // 是否显示下方小圆点
      type: Boolean,
      default: true
    },
    isShowLeftOrRightBtn: { // 是否显示左右按钮
      type: Boolean,
      default: true
    },
    duration: { // 切换间隔
      type: [Number, String],
      default: 5000
    },
    animationT: {
     type: Object,
     default: () => {
        return {
          speed: 20,
          speedTime: 20
        }
      }
    },
    styles: { // 自定义轮播图片宽高 默认500*300
      type: Object,
      default: () => {
        return {
          width: window.window.innerWidth,
          height: 3
        }
      }
    }
  },
  data () {
    return {
      active: 1, // 当前轮播图片
      timer: null,// 定时器
      len: 1,
      screenWidthtimer: false,
      screenWidth: window.window.innerWidth, // 屏幕宽度
    }
  },
	created(){},
  mounted () {
    if(this.sliderData.length>1){
      var mySwiper = new Swiper ('.swiperBox .swiper-container', {
          loop: true,
          // 如果需要分页器
          pagination:{
            el:'.swiper-pagination',
            clickable:true,
          },
          // 如果需要前进后退按钮
          nextButton: '.swiperBox .swiper-button-next',
          prevButton: '.swiperBox .swiper-button-prev',
      })
    }
  },

}
</script>
<style lang="less" scoped >
.swiperBox{
  width: 100%;
  overflow: hidden;
   .swiper-button-prev,.swiper-button-next{
            display: none;
   }
   &:hover{
       .swiper-button-prev,.swiper-button-next{
            display: block;
       }
   }

 /deep/ .swiper-pagination {
        .swiper-pagination-bullet{
         	width: 0.14rem;
			    height: 0.14rem;
        background: #0376be;
          border-radius: 50%;
          opacity: 1;
          &.swiper-pagination-bullet-active{
          //  width: 0.4rem!important;
          //   height: 0.08rem!important;
							width: 0.35rem;
              height: 0.14rem;
            // background: #0376be;
            opacity: 1;
            border-radius: 0.3rem;
        }

      }
   }
}
</style>



// WEBPACK FOOTER //
// src/components/slider.vue